var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hospital-layout-footer"},[_c('div',{staticClass:"copyright"},[_vm._m(0),_c('div',{staticStyle:{"margin-top":"18px"}},[_vm._v("Copyright © 2015-"+_vm._s(new Date().getFullYear())+"北京荣之联科技股份有限公司版权所有 ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n      京ICP备16042301号\n      "),_c('br')])
}]

export { render, staticRenderFns }